import { ReactComponent as Logo } from "../../assets/img/Logo.svg";
import styled from "styled-components";

import PreferencesList from "./Components/PreferencesList";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { PATH_PREFERENCE_MANAGEMENT_SUCCESS } from "constants/index";
import PreferenceManagementSuccess from "./Components/PreferenceManagementSuccess";

function PreferenceManagement(props: any) {
  let preferenceManagementState = useSelector((state: RootState) => state.preferenceManagement);
  const PrefBoxLoading = useSelector((state: RootState) => state.preferenceManagement.loading);
  return (
    <Wrapper>
      {window.location.pathname.includes(PATH_PREFERENCE_MANAGEMENT_SUCCESS) ? (
        <PreferenceManagementSuccess />
      ) : (
        <div className={`main-page ${PrefBoxLoading ? "height-setting" : ""}`}>
          <div className="page-headings">
            {!window.location.pathname.includes(PATH_PREFERENCE_MANAGEMENT_SUCCESS) && (
              <>
                {!PrefBoxLoading && <div className="logo-box" > {preferenceManagementState.logo_image_url ? <img className='img'
                  src={preferenceManagementState.logo_image_url}
                /> : <Logo className='img' />}</div>}
                <h2 className="heading-two">Preference Management</h2>
                <h5 className="heading-three">Pick and choose the communications that you are interested in.</h5>
                {preferenceManagementState.email !== "" && (
                  <h6 className="heading-four">({preferenceManagementState.email})</h6>
                )}
              </>
            )}
          </div>
          <div className="page-body">{<PreferencesList {...props} />}</div>
        </div>
      )}
    </Wrapper>
  );
}

export default PreferenceManagement;

const Wrapper = styled.div`
  .main-page {
    background-color: #f2f2f2;
    min-height: 100vh;
    padding-top: 47px;
    @media all and (max-width: 767px) {
      padding: 0 24px;
    }
  }
  .height-setting {
    height: 100vh;
  }
  .page-headings {
    text-align: center;
    @media all and (max-width: 767px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
  .heading-two {
    font-family: "Roboto Slab";
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 20px;
    letter-spacing: -0.9px;
    color: #424b50;
    margin-bottom: 24px;
    margin-top: 48px;
    @media all and (max-width: 767px){
      line-height: 33px;
    }
  }
  .heading-three {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: -0.555556px;
    color: #5e7079;
    margin-bottom: 8px;
  }
  .heading-four {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.555556px;
    color: #5e7079;
    opacity: 0.7;
    margin-bottom: 56px;
    @media all and (max-width: 767px) {
      margin-bottom: 49px;
    }
  }
  .page-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    @media all and (max-width: 767px) {
      align-items: unset;
    }
  }
  .preference-box {
    padding-bottom: 16px;
  }
  .button {
    text-align: center;
    padding: 32px 0 47px 0;
  }
  .btn {
    background: #1ec252;
    border: 1px solid #1ec252;
    border-radius: 8px;
    padding: 8px 55px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: #ffffff;
  }
  .logo-box {
    display: flex;
    justify-content: center;
    width: 300px;
    height: 80px;
    width: 100%;
    .img {
      height: 100%;
      width: 100%;
      object-fit: contain
    }
  }
`;
